var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCalendarIcon = function SvgCalendarIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#fff",
    fillRule: "evenodd",
    clipRule: "evenodd",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.57.6a1 1 0 0 1 1 1v1.133h4.858V1.6a1 1 0 1 1 2 0v1.133h1.286a1 1 0 0 1 1 1V14.4a1 1 0 0 1-1 1H2.285a1 1 0 0 1-1-1V3.733a1 1 0 0 1 1-1h1.286V1.6a1 1 0 0 1 1-1m6.858 4.133H3.285v1.734h9.429V4.733zM3.285 8.467h9.429V13.4H3.285z"
  })));
};
export default SvgCalendarIcon;